export default "__VITE_ASSET__3KmjerI0__"